// Funzione che crea il pdf-utente con il dettaglio di una submission list
import {jsPDF} from "jspdf";
import {
  CURRENCY_EURO,
  displayTranslations,
  isPresent,
  parseAmount,
  parseCategoryName,
  parseGameName,
  parseGradeOverall, parseUserFullName,
  titleize
} from "../utils";
import 'jspdf-autotable'
import I18n from 'i18n.js.erb'
import {koruri} from "./Koruri-Regular-normal";
import {koruriBold} from "./Koruri-Bold-normal";


const tab = "        "
const space = " "

const writeItalicText = (jsPDFDocument, text, xPosition, yPosition) => {
  jsPDFDocument.setFont('Helvetica', 'italic')
  jsPDFDocument.text(text, xPosition, yPosition)
  jsPDFDocument.setFont('Helvetica', '', '')
}

const writeBoldText = (jsPDFDocument, text, xPosition, yPosition) => {
  jsPDFDocument.setFont('Helvetica', '', 'Bold')
  jsPDFDocument.text(text, xPosition, yPosition)
  jsPDFDocument.setFont('Helvetica', '', '')
}




export const submissionListFulfillmentPDF = (submissionList) => {

  const doc = new jsPDF({orientation: "portrait"});
  doc.addFileToVFS("Koruri-Regular.ttf", koruri);
  doc.addFont("Koruri-Regular.ttf", "Koruri-Regular", "normal");
  doc.addFileToVFS("Koruri-Bold-normal.ttf", koruriBold);
  doc.addFont("Koruri-Bold-normal.ttf", "Koruri-Bold", "bold");
  doc.setFont('Helvetica')

  var img = new Image()
  img.src = '/images/logo-AIGRADING-white.png'
  doc.addImage(img, 15, 8, 52, 13)

  doc.setFontSize(16)
  writeBoldText(doc, I18n.t('js.editSubmissionListPage.webComponent.confirmation.text8'), 10, 35)

  doc.setFontSize(12)
  doc.text('1. ' + I18n.t('js.editSubmissionListPage.webComponent.confirmation.text9'), 10, 45)
  doc.text('2. ' + I18n.t('js.editSubmissionListPage.webComponent.confirmation.text10'), 10, 52)
  doc.text('3. ' + I18n.t('js.editSubmissionListPage.webComponent.confirmation.text10_1'), 10, 59)

  img = new Image()
  img.src = '/images/icons/cut.png'
  doc.addImage(img, 5, 69, 5, 5)
  doc.text('---------------------------------------------------------------------------------------------------------------------------------------', 12, 72)

  doc.rect(15, 77, doc.internal.pageSize.width / 2 - 10, 36)
  writeBoldText(doc, I18n.t('js.editSubmissionListPage.webComponent.confirmation.text4'), 20, 84)
  doc.text(submissionList.number.toString(), 20, 89)
  writeBoldText(doc, I18n.t('js.editSubmissionListPage.webComponent.confirmation.text4_1'), 20, 99)
  let yPosition = 99;
  if (submissionList.user_owner) {
    yPosition += 5;
    doc.text(submissionList.user_owner.toString(), 20, yPosition)
  }
  if (submissionList.owner_email && submissionList.owner_email !== submissionList.user_owner) {
    yPosition += 5;
    doc.text(submissionList.owner_email.toString(), 20, yPosition);
  }

  doc.text('----------------------------------------------------------------------------------------------------------------------------------------', 10, 119)

  doc.text('4. ' + I18n.t('js.editSubmissionListPage.webComponent.confirmation.text12'), 10, 133)


  if (!submissionList.home_pick_up_requested || submissionList.force_grader_company_address_rendering) {
    doc.text('5. ' + I18n.t('js.editSubmissionListPage.webComponent.confirmation.text13_1'), 10, 140)
    img.src = '/images/icons/cut.png'
    doc.addImage(img, 5, 150, 5, 5)
    doc.text('---------------------------------------------------------------------------------------------------------------------------------------', 12, 153)

    let address = submissionList.grader_company_shipment_address
    doc.rect(15, 158, doc.internal.pageSize.width / 2 - 10, 31)
    writeBoldText(doc, I18n.t('js.editSubmissionListPage.webComponent.confirmation.recipient'), 20, 165)
    doc.text(parseUserFullName(address.first_name, address.last_name), 20, 170)
    doc.text(address.street_square + space + address.number, 20, 175)
    doc.text(address.cap + ', ' + address.city + ' (' + address.province + ')', 20, 180)
    doc.text(address.country.toUpperCase(), 20, 185)

    doc.text('----------------------------------------------------------------------------------------------------------------------------------------', 10, 196)

    doc.text('6. ' + I18n.t('js.editSubmissionListPage.webComponent.confirmation.text16'), 10, 209)
    doc.text(
      '7. ' +
      I18n.t('js.editSubmissionListPage.webComponent.confirmation.text17') +
      space +
      submissionList.grader_company.meta_name + space +
      I18n.t('js.editSubmissionListPage.webComponent.confirmation.text18_1'), 10, 216)
    doc.text('    ' + I18n.t('js.editSubmissionListPage.webComponent.confirmation.text18_2'), 10, 221)
    doc.text(
      '8. ' +
      I18n.t('js.editSubmissionListPage.webComponent.confirmation.text19') +
      space +
      submissionList.grader_company.meta_name, 10, 228)
    doc.text('    ' + I18n.t('js.editSubmissionListPage.webComponent.confirmation.text20'), 10, 233)

    if (!submissionList.grader_company_delivery_method?.courier?.meta_name || submissionList.grader_company_delivery_method?.courier?.meta_name?.toLowerCase().indexOf('by hand') > -1)
      doc.text('    ' + I18n.t('js.editSubmissionListPage.webComponent.confirmation.text22_1'), 10, 238)
    else
      doc.text('    ' + I18n.t('js.editSubmissionListPage.webComponent.confirmation.text21'), 10, 238)

  } else {
    doc.text('5. ' + I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text3_2').split('#')[0], 10, 140)
    doc.text('    ' + I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text3_2').split('#')[1], 10, 145)
    doc.text('    ' + I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text3_3'), 10, 150)

    if (submissionList.home_pick_up_favorite_day_italian_format && submissionList.home_pick_up_favorite_hour_italian_format) {
      doc.text('6. ' +
        I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text5_2') + space +
        submissionList.home_pick_up_favorite_day_italian_format + space +
        I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text5_3') + space +
        submissionList.home_pick_up_favorite_hour_italian_format, 10, 159)
      doc.text('    ' + I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text5_4') + space + submissionList.grader_company.meta_name + '.', 10, 164)
    } else {
      doc.text('6. ' + I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text5') + space + submissionList.grader_company.meta_name + '.', 10, 159)
    }

    doc.text(
      '7. ' +
      I18n.t('js.editSubmissionListPage.webComponent.confirmation.text17') +
      space +
      submissionList.grader_company.meta_name + space +
      I18n.t('js.editSubmissionListPage.webComponent.confirmation.text18_1'), 10, 171)
    doc.text('    ' + I18n.t('js.editSubmissionListPage.webComponent.confirmation.text18_2'), 10, 176)
    doc.text(
      '8. ' +
      I18n.t('js.editSubmissionListPage.webComponent.confirmation.text19') +
      space +
      submissionList.grader_company.meta_name, 10, 184)
    doc.text('    ' + I18n.t('js.editSubmissionListPage.webComponent.confirmation.text20'), 10, 189)

    if (!submissionList.grader_company_delivery_method?.courier?.meta_name || submissionList.grader_company_delivery_method?.courier?.meta_name?.toLowerCase().indexOf('by hand') > -1)
      doc.text('    ' + I18n.t('js.editSubmissionListPage.webComponent.confirmation.text22_1'), 10, 194)
    else
      doc.text('    ' + I18n.t('js.editSubmissionListPage.webComponent.confirmation.text21'), 10, 194)
  }
  var pdfName= 'Order_Label_' + submissionList.number + '.pdf'
  doc.save(pdfName);
}
